import React from 'react';
import type { ChessPiece as ChessPieceType } from '../../../types/chess';

interface ChessPieceProps {
  piece: ChessPieceType;
}

export function ChessPiece({ piece }: ChessPieceProps) {
  const getPieceSymbol = () => {
    switch (piece.type) {
      case 'king': return '♔';
      case 'queen': return '♕';
      case 'rook': return '♖';
      case 'bishop': return '♗';
      case 'knight': return '♘';
      case 'pawn': return '♙';
    }
  };

  return (
    <span className={`text-2xl ${piece.color === 'white' ? 'text-cyan-400' : 'text-pink-500'}`}>
      {getPieceSymbol()}
    </span>
  );
}